
import Vue from "vue";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import {AWSFileService} from "@/services";
import { v4 } from "uuid";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true,
		}
	},
	computed: {
		allowedExtensions(): string[] {
			return ["jpg", "png"];
		},
		pathPrefix():string{
			return `/sale-rows/`+v4();
		},
		fileUrl():string{
			if(!this.state.selectedRow.CoverImageOverrideFileID){
				if(this.state.selectedRow.Product?.CoverImageID){
					return this.state.selectedRow?.Product?.CoverImage?.getFileUrl() || "";
				}
				return "";
			}
			return this.state.selectedRow?.CoverImageOverrideFile?.getUrl() || "";
		}
	},
	methods: {
		async onFile(file: File) {
			if (file.name.length > 128) {
				this.$wf.notify(this.$ct("error-file-name-too-long"), "danger", 3000, "exclamation-triangle");
				return;
			}
			let result = await AWSFileService.uploadFile(`${this.pathPrefix}`, file);
			this.$emit("file", result);
		},
		close(){
			this.$emit("close");
		},
		async clearImage(){
			let confirm = await this.$wf.confirm(
				this.$ct("confirm-delete-image"),
				this.$t("common.yes"),
				this.$t("common.no"),
				this.$t("common.warning"),
				"warning"
			);
			if (!confirm) return;
			this.$emit("clear");
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
